/* eslint-disable no-console */
import { LogLevel, Configuration, RedirectRequest } from "@azure/msal-browser";

/**
 * Configuration object to be passed to MSAL instance on creation.
 * For a full list of MSAL.js configuration parameters, visit
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */
export const msalConfig: Configuration = {
  auth: {
    clientId: process.env.REACT_APP_OIDC_CLIENT_ID || "missing",
    authority: process.env.REACT_APP_OIDC_AUTHORITY || "missing",
    redirectUri: process.env.REACT_APP_OIDC_REDIRECT_URI || "http://localhost:3000/",
    postLogoutRedirectUri: process.env.REACT_APP_OIDC_LOGOUT_REDIRECT_URI || "http://localhost:3000/"
  },
  cache: {
    cacheLocation: "sessionStorage", // This configures where your cache will be stored
    storeAuthStateInCookie: false // Set this to "true" if you are having issues on IE11 or Edge
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Info:
            // this produces too much noise for day to day use, if you need to debug
            // something uncomment it but please do not check it in that way
            //console.info(message);
            return;
          case LogLevel.Verbose:
            console.debug(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
        }
      }
    }
  }
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit:
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest: RedirectRequest = {
  redirectUri: process.env.REACT_APP_OIDC_REDIRECT_URI,
  scopes: (process.env.REACT_APP_OIDC_SCOPES || "none").split(","),
  prompt: "select_account"
};

/**
 * Add here the scopes to request when obtaining an access token for MS Graph API. For more information, see:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
 */
export const graphConfig = {
  graphApiRoot: "https://graph.microsoft.com/v1.0"
};
